import { Component, Injector, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ApplicationContextBoundComponent } from 'src/app/shared/components/application-context-bound.component';
import { CdContactInfo } from 'src/app/cd-request/models/closing-disclosure-doc-request.model';
import { EnumerationService } from 'src/app/services/enumeration-service';
import { EnumerationItem } from 'src/app/models/simple-enum-item.model';

export interface BuyerAgentFormData {
  noRealEstateAgent: boolean;
  companyName: string;
  companyLicenseId: string;
  address: string;
  city: string;
  state: string;
  zip: string;
  contactName: string;
  contactLicense: string;
  contactEmail: string;
  contactPhone: string;
}

@Component({
  selector: 'buyer-agent',
  templateUrl: './buyer-agent.component.html',
  styleUrls: ['./buyer-agent.component.scss'],
  standalone: false
})
export class BuyerAgentComponent extends ApplicationContextBoundComponent implements OnInit, OnChanges {

  @ViewChild('buyerAgentForm') buyerAgentForm: NgForm;

  @Input() buyerRealEstateAgent: CdContactInfo | undefined;
  @Input() noRealEstateAgentUsed: boolean | undefined;

  formData: BuyerAgentFormData = {
    noRealEstateAgent: false,
    companyName: '',
    companyLicenseId: '',
    address: '',
    city: '',
    state: '',
    zip: '',
    contactName: '',
    contactLicense: '',
    contactEmail: '',
    contactPhone: ''
  };

  isLoading: boolean = false;
  emailInvalid: boolean = false;
  states: EnumerationItem[] = [];

  constructor(
    protected readonly injector: Injector,
    private readonly _enumService: EnumerationService
  ) {
    super(injector);
    this.states = this._enumService.states;
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['buyerRealEstateAgent'] || changes['noRealEstateAgentUsed']) {
      this.populateFormFromApiData();
    }
  }

  validateForm(): boolean {
    if (this.formData.noRealEstateAgent) {
      return true;
    }
    if (this.buyerAgentForm) {
      this.buyerAgentForm.form.markAllAsTouched();
      return this.buyerAgentForm.form.valid;
    }
    return false;
  }

  getFormData(): BuyerAgentFormData {
    return { ...this.formData };
  }

  private populateFormFromApiData(): void {
    this.formData = {
      noRealEstateAgent: this.noRealEstateAgentUsed === true,
      companyName: this.buyerRealEstateAgent?.companyName || '',
      companyLicenseId: this.buyerRealEstateAgent?.companyLicenseId || '',
      address: this.buyerRealEstateAgent?.companyAddress || '',
      city: this.buyerRealEstateAgent?.city || '',
      state: this.buyerRealEstateAgent?.state || '',
      zip: this.buyerRealEstateAgent?.zip || '',
      contactName: this.buyerRealEstateAgent?.contactFullName || '',
      contactLicense: this.buyerRealEstateAgent?.contactLicenseId || '',
      contactEmail: this.buyerRealEstateAgent?.contactEmailAddress || '',
      contactPhone: this.buyerRealEstateAgent?.contactPhoneNumber || ''
    };
  }
}
